import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-cliente-form-input-disabled',
    templateUrl: 'cliente-form-input-disabled.component.html',
    styleUrls: ['./cliente-form-input-disabled.component.less']
})
export class ClienteFormInputDisabledComponent {
    @Input() codigoIntegracaoErp: string;
    @Input() nome: string;
    @Input() nomeFantasia: string;
    @Input() cnpjCpf: string;
    @Input() nomeCidade: string;
    @Input() uf: string;
    @Input() rotaEntregaErpSCR: string;
}

